// extracted by mini-css-extract-plugin
export default {"section":"_l7j0ZKEitbOjK4JmKAA","progress":"y5BUwlU5mfcXhveMtRSh"};